"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMachineAdvertising = setMachineAdvertising;
async function setMachineAdvertising(advertisingRepo, machineId, advertisingEnabled) {
    return advertisingRepo.setMachineAdvertising(machineId, advertisingEnabled);
}
